export const initialState = {
	user: [],
    isAuth:'',
	loading: false,
	error: '',
	update:[]
};